import { TextField } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { MIN_DURATION_MINUTES } from "../../hooks/useAppointments";
import { typography } from "../../utils/typography";
import { semanticColors } from "../../utils/colors";
import { warningOutlineSx } from "../../utils/fieldStyles";

/**
 * Duration in minutes. Held as raw text so the field can be cleared while
 * typing; `isDurationValid` tells the caller whether it can be scheduled.
 */
export function isDurationValid(value: string) {
  const minutes = parseInt(value, 10);
  return !isNaN(minutes) && minutes >= MIN_DURATION_MINUTES;
}

const helperTextSx = {
  ...typography.body.s,
  color: semanticColors.feedback.danger,
  ml: 0
};

export default function DurationField({
  value,
  onChange,
  sx
}: {
  value: string;
  onChange: (value: string) => void;
  sx?: SxProps<Theme>;
}) {
  const { t } = useTranslation();
  const invalid = !isDurationValid(value);
  return (
    <TextField
      type="number"
      label={t("videoConsultations.durationLabel")}
      value={value}
      onChange={e => onChange(e.target.value)}
      fullWidth
      error={invalid}
      helperText={
        invalid
          ? t("videoConsultations.durationMinError", {
              min: MIN_DURATION_MINUTES
            })
          : ""
      }
      FormHelperTextProps={{ sx: helperTextSx }}
      inputProps={{ min: MIN_DURATION_MINUTES, step: 5 }}
      sx={
        [...(Array.isArray(sx) ? sx : [sx]), warningOutlineSx] as SxProps<Theme>
      }
    />
  );
}
